import {SectionBgView} from './SectionBgView'
import {PIXI} from '@colonist/pixi'
import {Sound} from '../Sound'
import {SectionView} from './SectionView'
import {uiGameManager} from '../../../shared/scripts/EntryShared'
import {TranslationObject} from '@colonist/i18n'
import {Sprites} from '../ui_game/UIGameImageDictionary'
import {UIGameSpriteHandler} from '../UIGameSpriteHandler'
import {UIUtilsEjsVariables} from '../UIUtilsEjsVariables'
import {ToolTipText} from 'code/client/web/scripts/ui_game/ui_game_tooltip/UIWGameToolTipController'

export class GeneralButtonView extends SectionView {
    viewContainer: SectionBgView

    private action: (event) => void = () => undefined
    protected hoverOn: (event) => void = () => undefined
    protected hoverOut: (event) => void = () => undefined

    constructor(x: number, y: number, w: number, h: number, container: PIXI.Container, removePadding?: boolean) {
        super(x, y, w, h, container, removePadding)
        this.viewContainer = new SectionBgView(0, 0, this.width, this.height, this, true)
        this.viewContainer.drawRoundedBg(UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.bg_button), undefined, 0)
        this.setClickAction()
        this.setHover()
    }

    updateAction(action: (event: PIXI.FederatedPointerEvent) => void) {
        this.action = action
    }

    updateHover(pointerOverFunc: (event) => void, pointerOutFunc: (event) => void) {
        this.hoverOn = pointerOverFunc
        this.hoverOut = pointerOutFunc
    }

    setTip(title: TranslationObject, bodyParagraphs: TranslationObject[]) {
        const toolTipText: ToolTipText = () => ({title: title, body: bodyParagraphs})
        uiGameManager.toolTipController.createTip(toolTipText, this)
    }

    private setClickAction() {
        if(this.cursor != 'pointer') this.cursor = 'pointer'
        if(!this.interactive) this.interactive = true
        this.on('click', (event) => {
            this.action(event)
            Sound.playSound(Sound.SoundType.Click)
        })
        this.on('tap', (event) => {
            this.action(event)
            Sound.playSound(Sound.SoundType.Click)
        })
    }

    protected setHover() {
        this.interactive = true

        const isDiscordMobile = UIUtilsEjsVariables.isUserOnDiscordMobile
        const downEvent = isDiscordMobile ? 'pointerdown' : 'mouseover'
        const upEvent = isDiscordMobile ? 'pointerup' : 'mouseout'

        this.on(downEvent, (event) => {
            this.hoverSize()
            this.hoverOn(event)
        })
        this.on(upEvent, (event) => {
            this.returnToOriginalPosition()
            this.hoverOut(event)
        })

        if(isDiscordMobile) {
            this.on('pointerupoutside', (event) => {
                this.returnToOriginalPosition()
                this.hoverOut(event)
            })
        }
    }

    private hoverSize() {
        if(this.viewContainer.destroyed) return

        const growth = 0.05
        const x = this.viewContainer.x + this.viewContainer.width * growth / 2
        const y = this.viewContainer.y + this.viewContainer.height * growth / 2
        this.viewContainer.position.set(x, y)
        this.viewContainer.scale.set(0.95)
    }

    returnToOriginalPosition() {
        if(this.viewContainer.destroyed) return

        const {x, y} = this.viewContainer.initialPosition
        this.viewContainer.position.set(x, y)
        this.viewContainer.scale.set(1)
    }

    destroy() {
        this.viewContainer.destroy({children: true})
    }
}
